import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { CommonDialogs } from '../../constants/Dialogs';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import DialogStore from '../../stores/DialogStore';
import DialogActions from '../../actions/DialogActionCreator';


class ConfirmDialog extends Component {

    render() {
        if (this.state.open !== CommonDialogs.CONFIRM) { return null; } //guard

        const { title, onClose, onCancel, onConfirm, confirmButtonLabel, cancelButtonLabel, message, ...others } = this.props;

        return (
            <Dialog
                title={title}
                open={true}
                onRequestClose={onClose}
                actions={[
                    <FlatButton key="cancel" label={cancelButtonLabel} onTouchTap={onCancel}/>,
                    <FlatButton
                        key="save"
                        label={confirmButtonLabel}
                        onTouchTap={() => { onConfirm(); onClose(); }}
                        primary
                    />
                ]}
                {...others}
            >
                {message}
            </Dialog>
        );
    }
}

ConfirmDialog.getStores = () => [DialogStore];
ConfirmDialog.calculateState = () => ({ ...DialogStore.getState()});
ConfirmDialog.propTypes = {
    title:              PropTypes.string,
    message:            PropTypes.string,
    confirmButtonLabel: PropTypes.string,
    cancelButtonLabel:  PropTypes.string,
    onConfirm:          PropTypes.func.isRequired,
    onCancel:           PropTypes.func,
    onClose:            PropTypes.func
};
ConfirmDialog.defaultProps = {
    title:              'Confirm',
    message:            '',
    confirmButtonLabel: 'OK',
    cancelButtonLabel:  'Cancel',
    onCancel:           DialogActions.close,
    onClose:            DialogActions.close
};

export default Container.create(ConfirmDialog, { withProps: true });
